import { render, staticRenderFns } from "./selcetionClass.vue?vue&type=template&id=40541212&scoped=true&"
import script from "./selcetionClass.vue?vue&type=script&lang=js&"
export * from "./selcetionClass.vue?vue&type=script&lang=js&"
import style0 from "./selcetionClass.vue?vue&type=style&index=0&id=40541212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40541212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40541212')) {
      api.createRecord('40541212', component.options)
    } else {
      api.reload('40541212', component.options)
    }
    module.hot.accept("./selcetionClass.vue?vue&type=template&id=40541212&scoped=true&", function () {
      api.rerender('40541212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/sign-up/components/selcetionClass.vue"
export default component.exports